import { apiFetch } from "../api";

export const formatRouteDispatchError = (error) => {
  if (error?.code === 'DEAD_LETTER_RECONCILIATION_REQUIRED') return 'Confira este envio na Central de notificações antes de tentar novamente. A mensagem pode já ter sido recebida.';
  if (error?.code === 'NOTIFICATION_ALREADY_CLAIMED') return 'A mensagem está sendo processada. Atualize o andamento antes de retomar.';
  if (error?.code === "MOTORISTA_RESPOSTA_PENDENTE") {
    return error.message;
  }
  if (error?.code === "DIVERGENCIA_SGT" || error?.code === "CONFERENCIA_SGT_INDISPONIVEL") {
    return error.message;
  }
  if (error?.code === "TELEFONES_WHATSAPP_INVALIDOS") {
    const falhas = Array.isArray(error.falhas) ? error.falhas : [];
    const linhas = falhas.slice(0, 10).map((falha) => {
      const nome = falha.nome || "Destinatário";
      const telefone = falha.telefone_exibicao || falha.telefone || "—";
      const contexto = falha.regiao ? ` · ${falha.regiao}` : "";
      const motivo = falha.motivo || "não está no WhatsApp";
      return `${nome} (${telefone})${contexto} — ${motivo}`;
    });
    const base = error.message || "Há telefones inválidos para WhatsApp.";
    if (!linhas.length) return base;
    const restante = falhas.length > 10 ? ` … +${falhas.length - 10} restante(s)` : "";
    return `${base}\n${linhas.join("\n")}${restante}`;
  }
  return error?.message || "Erro ao disparar rota.";
};

const normalizeRouteGroups = (groups = []) => (
  groups.map((group) => ({
    regiao: group?.regiao || "",
    pessoas: Array.isArray(group?.pessoas)
      ? group.pessoas.map((pessoa) => ({
        ...pessoa,
        ...(pessoa?.id_pedido_origem ? { id_pedido_origem: pessoa.id_pedido_origem } : {}),
      }))
      : [],
    veiculo: group?.veiculo || null,
    motorista: group?.motorista || null,
    trecho: group?.trecho || null,
    programacao_responsavel_id: group?.programacao_responsavel_id || null,
    programacao_codigo_responsavel: group?.programacao_codigo_responsavel || null,
    planejamento_grupo_id: group?.planejamento_grupo_id || null,
    planejamento_van_numero: group?.planejamento_van_numero || null,
    conferida: Boolean(group?.conferida), conferida_em: group?.conferida_em || null, conferida_por: group?.conferida_por || null,
  }))
);

export const buildRoutePayload = ({ trecho, horario, data, idPedido, groups, empresaDestinoId, rotasOrigemIds }) => ({
  trecho,
  horario,
  data,
  id_pedido: idPedido?.trim() || null,
  empresa_destino_id: empresaDestinoId || null,
  rotas_origem_ids: Array.isArray(rotasOrigemIds)
    ? [...new Set(rotasOrigemIds.map(Number).filter((id) => Number.isInteger(id) && id > 0))]
    : [],
  grupos: normalizeRouteGroups(groups),
});

export const buildRouteRegistrationBody = ({ trecho, horario, data, idPedido, groups, status, isTestRoute, empresaDestinoId, clienteId, rotasOrigemIds }) => {
  const normalizedGroups = normalizeRouteGroups(groups);

  return {
    trecho,
    horario,
    data,
    id_pedido: idPedido?.trim() || null,
    cliente_id: clienteId || null,
    total_grupos: normalizedGroups.length,
    total_passageiros: normalizedGroups.reduce((total, group) => total + group.pessoas.length, 0),
    regioes: [...new Set(normalizedGroups.map((group) => group.regiao).filter(Boolean))],
    motoristas: [...new Set(normalizedGroups.map((group) => group.motorista?.nome).filter(Boolean))],
    veiculos: [...new Set(normalizedGroups.map((group) => group.veiculo ? `${group.veiculo.veiculo} (${group.veiculo.placa})` : "").filter(Boolean))],
    status,
    is_teste: Boolean(isTestRoute),
    payload: buildRoutePayload({ trecho, horario, data, idPedido, groups: normalizedGroups, empresaDestinoId, rotasOrigemIds }),
  };
};

export const formatPhoneValidationFalhas = (falhas = []) => (
  falhas.map((falha) => {
    const nome = falha.nome || "Destinatário";
    const telefone = falha.telefone_exibicao || falha.telefone || "—";
    const contexto = falha.regiao ? ` · ${falha.regiao}` : "";
    const motivo = falha.motivo || "não está no WhatsApp";
    return `${nome} (${telefone})${contexto} — ${motivo}`;
  })
);

const formatSgtTrecho = (trecho) => (
  trecho === "ida" ? "IDA" : trecho === "volta" ? "VOLTA" : (trecho || "—")
);

const formatSgtData = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : (value || "—");
};

const formatSgtNomes = (lista = []) => lista.map((p) => p?.nome || "?").join(", ");

export const formatSgtConferencias = (conferencias = []) => (
  conferencias
    .filter((conferencia) => conferencia.status !== "ok")
    .map((conferencia) => {
      if (conferencia.status === "recusado") {
        return {
          id_pedido: conferencia.id_pedido,
          linhas: ["Pedido recusado pela central no SGT."],
        };
      }
      if (conferencia.status === "nao_encontrado") {
        return {
          id_pedido: conferencia.id_pedido,
          linhas: ["Pedido não encontrado na última busca do SGT."],
        };
      }
      const review = conferencia.review || {};
      const divergencias = review.divergencias || {};
      const linhas = [];
      if (review.horario_ok === false) {
        linhas.push(`Horário — SGT: ${divergencias.horario?.embraer || "—"} · Sistema: ${divergencias.horario?.sistema || "—"}`);
      }
      if (review.trecho_ok === false) {
        linhas.push(`Trecho — SGT: ${formatSgtTrecho(divergencias.trecho?.embraer)} · Sistema: ${formatSgtTrecho(divergencias.trecho?.sistema)}`);
      }
      if (review.data_ok === false) {
        linhas.push(`Data — SGT: ${formatSgtData(divergencias.data?.embraer)} · Sistema: ${formatSgtData(divergencias.data?.sistema)}`);
      }
      if (divergencias.passageiros_faltando_no_sistema?.length) {
        linhas.push(`No SGT, mas fora da van: ${formatSgtNomes(divergencias.passageiros_faltando_no_sistema)}`);
      }
      if (divergencias.passageiros_extras_no_sistema?.length) {
        linhas.push(`Na van, mas não no SGT: ${formatSgtNomes(divergencias.passageiros_extras_no_sistema)}`);
      }
      return { id_pedido: conferencia.id_pedido, linhas };
    })
);

export const dispatchRouteGroups = async ({
  trecho,
  groups,
  routeId,
  ignorarValidacaoTelefone = false,
  ignorarValidacaoSgt = false,
  sgtSnapshotId = null,
  sgtOverrideMotivo = "",
}) => {
  if (!routeId) {
    throw new Error("A rota precisa estar salva antes do disparo.");
  }

  // Preflight da rota inteira ANTES de qualquer grupo ser enviado: se algum
  // grupo divergir do SGT, nada foi disparado ainda quando o 409 chega.
  // O snapshot_id retornado pina todos os grupos na mesma versão validada
  // (o cron pode gravar um snapshot novo no meio do loop). O backend revalida
  // a rota inteira em cada grupo como última barreira.
  let snapshotId = sgtSnapshotId;
  if (!ignorarValidacaoSgt) {
    const preflight = await apiFetch(`/rotas/${routeId}/validar-sgt`, { method: "POST" });
    snapshotId = preflight?.snapshot_id || null;
  }

  const results = [];

  for (const [groupIndex, group] of normalizeRouteGroups(groups).entries()) {
    const response = await apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/disparar`, {
      method: "POST",
      body: JSON.stringify({
        ignorar_validacao_telefone: Boolean(ignorarValidacaoTelefone) && groupIndex === 0,
        // Diferente do telefone, a validação SGT roda em todo grupo — o
        // "continuar mesmo assim" vale para o disparo inteiro desta rota.
        ignorar_validacao_sgt: Boolean(ignorarValidacaoSgt),
        ...(snapshotId ? { sgt_snapshot_id: snapshotId } : {}),
        ...(ignorarValidacaoSgt && sgtOverrideMotivo
          ? { sgt_override_motivo: sgtOverrideMotivo }
          : {}),
      }),
    });

    results.push({
      ...(response?.group || group),
      trecho: response?.group?.trecho || group.trecho || trecho,
      documento_id: response?.documento?.id || null,
      skipped: Boolean(response?.skipped),
      pendencias_anteriores_expiradas: Array.isArray(response?.pendencias_anteriores_expiradas)
        ? response.pendencias_anteriores_expiradas
        : [],
    });
  }

  return results;
};

const wait = (milliseconds) => new Promise((resolve) => {
  globalThis.setTimeout(resolve, milliseconds);
});

export const waitForRouteCommunication = async ({
  routeId,
  timeoutMs = 30000,
  intervalMs = 1000,
  onUpdate,
}) => {
  const startedAt = Date.now();
  let lastSummary = null;

  while (Date.now() - startedAt <= timeoutMs) {
    lastSummary = await apiFetch(`/rotas/${routeId}/resumo-comunicacao`);
    onUpdate?.(lastSummary);
    if (Number(lastSummary?.falhas || 0) > 0) {
      const error = new Error(
        `A comunicação falhou para ${lastSummary.falhas} grupo(s). Consulte a Central de notificações antes de reenviar.`
      );
      error.code = "ROUTE_COMMUNICATION_FAILED";
      error.resumo_comunicacao = lastSummary;
      throw error;
    }
    if (lastSummary?.can_close) return lastSummary;
    await wait(intervalMs);
  }

  const error = new Error(
    "As mensagens foram aceitas e continuam sendo processadas. A rota será movida automaticamente para Em operação após a confirmação da Meta."
  );
  error.code = "ROUTE_COMMUNICATION_PENDING";
  error.resumo_comunicacao = lastSummary;
  throw error;
};

export const finalizeRouteDispatch = async ({ routeId, waitOptions } = {}) => {
  if (!routeId) throw new Error("A rota precisa estar salva antes da confirmação.");
  await waitForRouteCommunication({ routeId, ...(waitOptions || {}) });
  return apiFetch(`/rotas/${routeId}/confirmar-envio`, { method: "POST" });
};

export const dispatchPlanningVan = async ({ route, onProgress, retry = false, ignorarValidacaoTelefone = false }) => {
  const context = { routeId: route.id, vanNumber: route.payload.grupos[0].planejamento_van_numero || 1 };
  try {
    onProgress?.({ ...context, status: 'sending' });
    if (retry) {
      const documentId = route.envios_grupos?.[0]?.documento_id;
      if (documentId) {
        const contextId = `${route.id}:0:${documentId}`;
        const notifications = await apiFetch(`/notifications?context_type=rota_grupo_inicial&context_id=${encodeURIComponent(contextId)}&limit=100`);
        const failed = (notifications.items || notifications.notifications || []).filter((item) => ['failed','dead_letter'].includes(item.status));
        for (const notification of failed) await apiFetch(`/notifications/${notification.id}/resend`, { method: 'POST' });
      }
    }
    await dispatchRouteGroups({ routeId: route.id, groups: route.payload.grupos, trecho: route.trecho, ignorarValidacaoTelefone });
    onProgress?.({ ...context, status: 'awaiting' });
    await finalizeRouteDispatch({ routeId: route.id, waitOptions: { onUpdate: () => onProgress?.({ ...context, status: 'awaiting' }) } });
    const result = { ...context, status: 'sent' }; onProgress?.(result); return result;
  } catch (error) {
    const result = { ...context, status: error.code === 'ROUTE_COMMUNICATION_PENDING' ? 'pending' : 'failed',
      message: formatRouteDispatchError(error), code: error.code, falhas: error.falhas || [], conferencias: error.conferencias || [] };
    onProgress?.(result); return result;
  }
};

export const retryPlanningVan = async ({ routeId, onProgress }) => {
  const route = await apiFetch(`/rotas/${routeId}`);
  return dispatchPlanningVan({ route, onProgress, retry: true });
};

export const sendPlanningVans = async ({ route, groupIds, ignorarValidacaoTelefone = false, onPrepared, onProgress }) => {
  const prepared = await apiFetch(`/rotas/${route.id}/preparar-vans`, {
    method: "POST", body: JSON.stringify({ grupo_ids: groupIds, edit_version: route.edit_version }),
  });
  onPrepared?.(prepared);
  const results = [];
  for (const operational of prepared.rotas) {
    results.push(await dispatchPlanningVan({ route: operational, ignorarValidacaoTelefone, onProgress }));
  }
  return { ...prepared, results };
};

export const planningDispatchMessage = (results = [], remainingCount = 0) => {
  const sent = results.filter((item) => item.status === "sent").length;
  const pending = results.filter((item) => item.status === "pending").length;
  const failed = results.filter((item) => item.status === "failed");
  return [sent ? `${sent} ${sent === 1 ? 'van enviada' : 'vans enviadas'}.` : "", pending ? `${pending} ${pending === 1 ? 'van aguardando' : 'vans aguardando'} confirmação do canal.` : "",
    failed.length ? `${failed.length} ${failed.length === 1 ? 'van com problema' : 'vans com problemas'} no envio. Corrija e retome somente essas vans. ${failed[0].message}` : "",
    remainingCount ? `${remainingCount} ${remainingCount === 1 ? 'van continua salva' : 'vans continuam salvas'} em Planejamento.` : "Todas as vans selecionadas estão em Em operação."].filter(Boolean).join(" ");
};

export const addPassengerToRouteGroup = async ({
  routeId,
  groupIndex,
  funcionarioId,
  funcionarioIds,
  programacaoId = null,
  programacaoCodigo = "",
  criarProgramacao = false,
  programacaoData = "",
  programacaoHorario = "",
  confirmarVinculoProgramacao = false,
}) => {
  if (!routeId) throw new Error("A rota precisa estar salva.");
  if (!Number.isInteger(groupIndex) || groupIndex < 0) {
    throw new Error("Grupo da rota inválido.");
  }

  const ids = Array.isArray(funcionarioIds)
    ? [...new Set(funcionarioIds.map(Number).filter(Boolean))]
    : funcionarioId
      ? [Number(funcionarioId)]
      : [];

  if (!ids.length) throw new Error("Selecione ao menos um funcionário.");

  return apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/adicionar-passageiro`, {
    method: "POST",
    body: JSON.stringify({
      funcionario_ids: ids,
      ...(programacaoId ? { programacao_id: Number(programacaoId) } : {}),
      ...(String(programacaoCodigo || "").trim()
        ? {
          programacao_codigo: String(programacaoCodigo).trim(),
        }
        : {}),
      ...(confirmarVinculoProgramacao ? { confirmar_vinculo_programacao: true } : {}),
      ...(criarProgramacao
        ? {
          criar_programacao: true,
          programacao_data: String(programacaoData || "").substring(0, 10),
          programacao_horario: String(programacaoHorario || "").trim(),
        }
        : {}),
    }),
  });
};

export const removePassengerFromRouteGroup = async ({ routeId, groupIndex, funcionarioId }) => {
  if (!routeId) throw new Error("A rota precisa estar salva.");
  if (!Number.isInteger(groupIndex) || groupIndex < 0) {
    throw new Error("Grupo da rota inválido.");
  }
  if (!Number(funcionarioId)) throw new Error("Passageiro inválido.");

  return apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/passageiros/${Number(funcionarioId)}`, {
    method: "DELETE",
  });
};

export const correctRouteGroupData = async ({
  routeId,
  groupIndex,
  horario,
  programacaoId = null,
  programacaoCodigo = null,
  motivo,
  confirmarCorrecao = false,
}) => {
  if (!routeId) throw new Error("A rota precisa estar salva.");
  if (!Number.isInteger(groupIndex) || groupIndex < 0) {
    throw new Error("Grupo da rota inválido.");
  }

  return apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/corrigir-dados`, {
    method: "PATCH",
    body: JSON.stringify({
      horario,
      ...(programacaoId ? { programacao_id: Number(programacaoId) } : {}),
      ...(programacaoCodigo !== null ? { programacao_codigo: String(programacaoCodigo).trim() } : {}),
      motivo: String(motivo || "").trim(),
      confirmar_correcao: Boolean(confirmarCorrecao),
    }),
  });
};

export const resendRouteGroupNotifications = async ({
  routeId,
  groupIndex,
  funcionarioIds = null,
  incluirMotorista = true,
}) => {
  if (!routeId) throw new Error("A rota precisa estar salva.");
  if (!Number.isInteger(groupIndex) || groupIndex < 0) {
    throw new Error("Grupo da rota inválido.");
  }

  const body = { incluir_motorista: incluirMotorista };
  if (Array.isArray(funcionarioIds) && funcionarioIds.length) {
    body.funcionario_ids = funcionarioIds.map(Number).filter(Boolean);
  }

  return apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/reenviar-notificacoes`, {
    method: "POST",
    headers: {
      "Idempotency-Key": globalThis.crypto?.randomUUID?.()
        || `manual-resend-${Date.now()}-${Math.random().toString(16).slice(2)}`,
    },
    body: JSON.stringify(body),
  });
};

export const resendRouteGroupReminders = async ({
  routeId,
  groupIndex,
  tipos = null,
  funcionarioIds = null,
}) => {
  if (!routeId) throw new Error("A rota precisa estar salva.");
  if (!Number.isInteger(groupIndex) || groupIndex < 0) {
    throw new Error("Grupo da rota inválido.");
  }

  const body = {};
  if (Array.isArray(tipos) && tipos.length) body.tipos = tipos;
  if (Array.isArray(funcionarioIds) && funcionarioIds.length) {
    body.funcionario_ids = funcionarioIds.map(Number).filter(Boolean);
  }

  return apiFetch(`/rotas/${routeId}/grupos/${groupIndex}/reenviar-lembretes`, {
    method: "POST",
    body: JSON.stringify(body),
  });
};
